import { render } from "./ShueishaPublicationProfile.vue?vue&type=template&id=a230d7a6&scoped=true&ts=true"
import script from "./ShueishaPublicationProfile.vue?vue&type=script&lang=ts"
export * from "./ShueishaPublicationProfile.vue?vue&type=script&lang=ts"

import "./ShueishaPublicationProfile.vue?vue&type=style&index=0&id=a230d7a6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3623750061/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a230d7a6"]])

export default __exports__